webpackJsonp([1],{

/***/ 246:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(305)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(275),
  /* template */
  __webpack_require__(438),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 247:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(309)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(276),
  /* template */
  __webpack_require__(444),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 248:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(311)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(278),
  /* template */
  __webpack_require__(448),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 249:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(307)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(279),
  /* template */
  __webpack_require__(441),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 250:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(313)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(280),
  /* template */
  __webpack_require__(451),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 251:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(281),
  /* template */
  __webpack_require__(449),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 252:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(314)
}
var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(452),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 253:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(285),
  /* template */
  __webpack_require__(436),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 273:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LightboxStore__ = __webpack_require__(47);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].directive('lightbox', {
  bind: function bind(el) {
    var index = __WEBPACK_IMPORTED_MODULE_1__LightboxStore__["a" /* default */].addImage(el.getAttribute('href'));

    el.addEventListener('click', function (e) {
      e.preventDefault();
      __WEBPACK_IMPORTED_MODULE_1__LightboxStore__["a" /* default */].open(index);
    });
  },
  unbind: function unbind(el) {
    __WEBPACK_IMPORTED_MODULE_1__LightboxStore__["a" /* default */].removeImage(el.getAttribute('href'));
  }
});

/***/ }),

/***/ 274:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_google_maps__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_analytics__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Home__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_About__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_About___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_About__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_TodoList__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_TodoList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_TodoList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_PhotoSet__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_PhotoSet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_PhotoSet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Photos__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Photos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_Photos__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Places__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Places___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_Places__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Test__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Test___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_Test__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_lightbox_LightboxImage__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_lightbox_LightboxImage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_lightbox_LightboxImage__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('lightbox-image', __WEBPACK_IMPORTED_MODULE_12__components_lightbox_LightboxImage___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue2_google_maps__, {
  load: {
    key: '' + "AIzaSyBS0BW3vw0RfQ3sozyQFG2lMooCjb0uXfs"
  }
});
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{ path: '/', component: __WEBPACK_IMPORTED_MODULE_5__components_Home___default.a }, { path: '/about', component: __WEBPACK_IMPORTED_MODULE_6__components_About___default.a }, { path: '/todo-list', component: __WEBPACK_IMPORTED_MODULE_7__components_TodoList___default.a }, { path: '/places', component: __WEBPACK_IMPORTED_MODULE_10__components_Places___default.a }, { path: '/places/:id', component: __WEBPACK_IMPORTED_MODULE_10__components_Places___default.a }, { path: '/photos/:name', component: __WEBPACK_IMPORTED_MODULE_8__components_PhotoSet___default.a }, { path: '/photos', component: __WEBPACK_IMPORTED_MODULE_9__components_Photos___default.a }, { path: '/test', component: __WEBPACK_IMPORTED_MODULE_11__components_Test___default.a }]
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_analytics___default.a, {
  id: '' + "UA-2669425-1",
  router: router
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: router,
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_4__App___default.a }
}).$mount('#app');

/***/ }),

/***/ 275:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  data: function data() {
    return {
      activeClass: '/'
    };
  },

  watch: {
    $route: function $route(to) {
      var self = this;
      if (to.path.startsWith('/photos')) {
        self.activeClass = '/photos';
      } else {
        self.activeClass = to.path;
      }
    }
  }
});

/***/ }),

/***/ 276:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TodoList__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TodoList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__TodoList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CreateTodo__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CreateTodo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__CreateTodo__);
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'about',
  components: {
    TodoList: __WEBPACK_IMPORTED_MODULE_0__TodoList___default.a,
    CreateTodo: __WEBPACK_IMPORTED_MODULE_1__CreateTodo___default.a
  },
  methods: {
    createTodo: function createTodo(newTodo) {
      this.todos.push(newTodo);
    }
  },
  data: function data() {
    return {
      todos: [{
        title: 'Todo A',
        project: 'Project A',
        done: false
      }, {
        title: 'Todo B',
        project: 'Project B',
        done: true
      }, {
        title: 'Todo C',
        project: 'Project C',
        done: false
      }, {
        title: 'Todo D',
        project: 'Project D',
        done: false
      }]
    };
  }
});

/***/ }),

/***/ 277:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      titleText: '',
      projectText: '',
      isCreating: false
    };
  },

  methods: {
    openForm: function openForm() {
      this.isCreating = true;
    },
    closeForm: function closeForm() {
      this.isCreating = false;
    },
    sendForm: function sendForm() {
      if (this.titleText.length > 0 && this.projectText.length > 0) {
        var title = this.titleText;
        var project = this.projectText;
        this.$emit('create-todo', {
          title: title,
          project: project,
          done: false
        });
        this.isCreating = false;
        this.titleText = '';
        this.projectText = '';
      }
    }
  }
});

/***/ }),

/***/ 278:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      contentList: [{ name: '', thumbnail: '', description: '' }, { name: '', thumbnail: '', description: '' }, { name: '', thumbnail: '', description: '' }],
      placesList: [{ name: '', description: '', latitude: '', longitude: '' }, { name: '', description: '', latitude: '', longitude: '' }, { name: '', description: '', latitude: '', longitude: '' }],
      postsList: [{ title: '', content: '', url: '' }, { title: '', content: '', url: '' }, { title: '', content: '', url: '' }],
      api_key: '' + "AIzaSyBS0BW3vw0RfQ3sozyQFG2lMooCjb0uXfs"
    };
  },
  mounted: function mounted() {
    this.getSets();
    this.getPlaces();
    this.getBlogPosts();
  },

  methods: {
    firstLetter: function firstLetter(input) {
      return input.substring(0, 1);
    },
    setNamePlus: function setNamePlus(input) {
      return input.name.replace(/ /g, '+');
    },
    getSets: function getSets() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("https://api.mcanoy.com" + '/pictureSets?sort=id,desc&size=3').then(function (response) {
        self.contentList = response.data.content;
      });
    },
    getPlaces: function getPlaces() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("https://api.mcanoy.com" + '/places?sort=id,desc&size=3').then(function (response) {
        self.placesList = response.data.content;
      });
    },
    getBlogPosts: function getBlogPosts() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("https://api.mcanoy.com" + '/blogs').then(function (response) {
        self.postsList = response.data;
      });
    }
  }
});

/***/ }),

/***/ 279:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lightbox_Lightbox__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lightbox_Lightbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__lightbox_Lightbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lightbox_LightboxStore__ = __webpack_require__(47);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Lightbox: __WEBPACK_IMPORTED_MODULE_1__lightbox_Lightbox___default.a
  },
  data: function data() {
    return {
      imageItems: [],
      setDetails: {}
    };
  },
  mounted: function mounted() {
    this.getPictureSetPictures(this.$route.params.name);
    this.getPictureSetDetails(this.$route.params.name);
  },
  beforeRouteUpdate: function beforeRouteUpdate(to) {
    this.getPictureSetPictures(to.params.name);
    this.getPictureSetDetails(to.params.name);
  },

  methods: {
    getPictureSetDetails: function getPictureSetDetails(url) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("https://api.mcanoy.com" + '/pictureSets/search/name?name=' + url + '&status=1').then(function (response) {
        self.setDetails = response.data;
      });
    },
    getPictureSetPictures: function getPictureSetPictures(url) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_2__lightbox_LightboxStore__["a" /* default */].close();
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("https://api.mcanoy.com" + '/pictures/search/name?name=' + url + '&status=1').then(function (response) {
        self.imageItems = response.data.content;
      });
    }
  }
});

/***/ }),

/***/ 280:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      sets: []
    };
  },
  mounted: function mounted() {
    this.getSets();
  },

  methods: {
    setNamePlus: function setNamePlus(input) {
      return input.name.replace(/ /g, '+');
    },
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format('MMM Do YY');
    },
    maxChars: function maxChars(text, length) {
      var modString = text;
      var maxLength = length - 2;
      if (!text) {
        modString = 'n/a';
      }
      return modString.length < length ? modString : modString.substring(0, maxLength) + '...';

      // const maxLength = length - 2;
      // return text && text.length < length ? text : `${text.substring(0, maxLength)}...`;
    },
    getSets: function getSets() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("https://api.mcanoy.com" + '/pictureSets/search/status?status=1&sort=sequence&size=300').then(function (response) {
        self.sets = response.data.content;
      });
    }
  }
});

/***/ }),

/***/ 281:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      infoContent: 'blah',
      infoWinOpen: false,
      infoWindowPos: {
        lat: 34.090698,
        lng: -118.38600
      },
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        },
        content: 'ffffff'
      },
      center: {
        lat: 40.7570262523253,
        lng: -73.9853024482727
      },
      zoom: 12,
      markers: []
    };
  },
  mounted: function mounted() {
    var self = this;
    if (navigator.geolocation && !this.$route.params.id) {
      navigator.geolocation.getCurrentPosition(function (position) {
        var lat = position.coords.latitude;
        var lng = position.coords.longitude;

        self.center = { lat: lat, lng: lng };
      });
    }
    this.getPlaces();
    this.routeMarker();
  },

  methods: {
    firstLetter: function firstLetter(marker) {
      return marker.rating === 1 ? '' : marker.name.substring(0, 1);
    },
    getIcon: function getIcon(marker) {
      return marker.rating === 1 ? '/static/images/black_star.png' : '';
    },
    getPlaces: function getPlaces() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("https://api.mcanoy.com" + '/places?sort=id,desc&size=500').then(function (response) {
        self.markers = response.data.content;
      });
    },
    toggleInfoWindow: function toggleInfoWindow(marker, idx) {
      var self = this;
      self.infoWindowPos = { lat: marker.latitude, lng: marker.longitude };
      var placeName = marker.url === '' ? marker.name : '<a href=\'' + marker.url + '\' target=\'_blank\'>' + marker.name + '</a>';
      var placeIcon = marker.icon === '' ? '' : '<p><img src=\'' + marker.icon + '\' style=\'float:left;padding:3px\'/><p>';
      self.infoContent = '<p>' + placeName + '</p>' + placeIcon + '<p>' + marker.description + '</p>';
      self.infoOptions.content = self.infoContent;

      // check if its the same marker that was selected if yes toggle
      if (self.currentMidx === idx) {
        self.infoWinOpen = !self.infoWinOpen;
      } else {
        // if different marker set infowindow to open and reset current marker index
        self.infoWinOpen = true;
        self.currentMidx = idx;
      }
    },
    routeMarker: function routeMarker() {
      var _this = this;

      if (this.$route.params.id) {
        var self = this;
        var placeId = this.$route.params.id;
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get("https://api.mcanoy.com" + '/places/search/name?name=' + placeId).then(function (response) {
          _this.toggleInfoWindow(response.data, -1);
          self.center = self.infoWindowPos;
          self.zoom = 25;
        });
      }
    }
  }
});

/***/ }),

/***/ 282:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['todo'],
  data: function data() {
    return {
      isEditing: false
    };
  },

  methods: {
    showForm: function showForm() {
      this.isEditing = true;
    },
    hideForm: function hideForm() {
      this.isEditing = false;
    },
    deleteTodo: function deleteTodo(todo) {
      this.$emit('delete-todo', todo);
    },
    completeTodo: function completeTodo(todo) {
      this.$emit('complete-todo', todo);
    }
  }
});

/***/ }),

/***/ 283:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Todo__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Todo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Todo__);
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['todos'],
  components: {
    Todo: __WEBPACK_IMPORTED_MODULE_0__Todo___default.a
  },
  methods: {
    deleteTodo: function deleteTodo(todo) {
      var todoIndex = this.todos.indexOf(todo);
      this.todos.splice(todoIndex, 1);
    },
    completeTodo: function completeTodo(todo) {
      var todoIndex = this.todos.indexOf(todo);
      this.todos[todoIndex].done = true;
    }
  }
});

/***/ }),

/***/ 284:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LightboxDirective__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LightboxStore__ = __webpack_require__(47);
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      state: __WEBPACK_IMPORTED_MODULE_1__LightboxStore__["a" /* default */].state,
      direction: 'next'
    };
  },

  methods: {
    close: function close() {
      __WEBPACK_IMPORTED_MODULE_1__LightboxStore__["a" /* default */].close();
    },
    next: function next() {
      this.direction = 'next';
      __WEBPACK_IMPORTED_MODULE_1__LightboxStore__["a" /* default */].next();
    },
    prev: function prev() {
      this.direction = 'prev';
      __WEBPACK_IMPORTED_MODULE_1__LightboxStore__["a" /* default */].prev();
    }
  },
  computed: {
    image: function image() {
      if (this.state.index) {
        return this.state.images[this.state.index];
      }

      return false;
    },
    transition: function transition() {
      return 'lightbox-' + this.direction;
    }
  }
});

/***/ }),

/***/ 285:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    image: String
  },
  data: function data() {
    return {
      loading: true,
      src: false,
      style: {}
    };
  },

  methods: {
    resizeImage: function resizeImage(image) {
      var width = image.width;
      var height = image.height;

      if (width > window.innerWidth || height > window.innerHeight) {
        var ratio = width / height;
        var windowRatio = window.innerWidth / window.innerHeight;
        if (ratio > windowRatio) {
          width = window.innerWidth;
          height = width / ratio;
        } else {
          height = window.innerHeight;
          width = height * ratio;
        }
      }

      this.style = {
        width: width + 'px',
        height: height + 'px',
        top: (window.innerHeight - height) * 0.5 + 'px',
        left: (window.innerWidth - width) * 0.5 + 'px'
      };
    }
  },
  mounted: function mounted() {
    var _this = this;

    var image = new window.Image();

    image.onload = function () {
      _this.loading = false;
      _this.src = _this.image;
      _this.resizeImage(image);
    };
    image.src = this.image;

    this.resizeEvent = function () {
      _this.resizeImage(image);
    };

    window.addEventListener('resize', this.resizeEvent);
  },
  destroyed: function destroyed() {
    window.removeEventListener('resize', this.resizeEvent);
  }
});

/***/ }),

/***/ 305:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 306:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 307:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 308:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 309:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 310:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 311:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 312:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 313:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 314:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 426:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 119,
	"./af.js": 119,
	"./ar": 126,
	"./ar-dz": 120,
	"./ar-dz.js": 120,
	"./ar-kw": 121,
	"./ar-kw.js": 121,
	"./ar-ly": 122,
	"./ar-ly.js": 122,
	"./ar-ma": 123,
	"./ar-ma.js": 123,
	"./ar-sa": 124,
	"./ar-sa.js": 124,
	"./ar-tn": 125,
	"./ar-tn.js": 125,
	"./ar.js": 126,
	"./az": 127,
	"./az.js": 127,
	"./be": 128,
	"./be.js": 128,
	"./bg": 129,
	"./bg.js": 129,
	"./bn": 130,
	"./bn.js": 130,
	"./bo": 131,
	"./bo.js": 131,
	"./br": 132,
	"./br.js": 132,
	"./bs": 133,
	"./bs.js": 133,
	"./ca": 134,
	"./ca.js": 134,
	"./cs": 135,
	"./cs.js": 135,
	"./cv": 136,
	"./cv.js": 136,
	"./cy": 137,
	"./cy.js": 137,
	"./da": 138,
	"./da.js": 138,
	"./de": 141,
	"./de-at": 139,
	"./de-at.js": 139,
	"./de-ch": 140,
	"./de-ch.js": 140,
	"./de.js": 141,
	"./dv": 142,
	"./dv.js": 142,
	"./el": 143,
	"./el.js": 143,
	"./en-au": 144,
	"./en-au.js": 144,
	"./en-ca": 145,
	"./en-ca.js": 145,
	"./en-gb": 146,
	"./en-gb.js": 146,
	"./en-ie": 147,
	"./en-ie.js": 147,
	"./en-nz": 148,
	"./en-nz.js": 148,
	"./eo": 149,
	"./eo.js": 149,
	"./es": 151,
	"./es-do": 150,
	"./es-do.js": 150,
	"./es.js": 151,
	"./et": 152,
	"./et.js": 152,
	"./eu": 153,
	"./eu.js": 153,
	"./fa": 154,
	"./fa.js": 154,
	"./fi": 155,
	"./fi.js": 155,
	"./fo": 156,
	"./fo.js": 156,
	"./fr": 159,
	"./fr-ca": 157,
	"./fr-ca.js": 157,
	"./fr-ch": 158,
	"./fr-ch.js": 158,
	"./fr.js": 159,
	"./fy": 160,
	"./fy.js": 160,
	"./gd": 161,
	"./gd.js": 161,
	"./gl": 162,
	"./gl.js": 162,
	"./gom-latn": 163,
	"./gom-latn.js": 163,
	"./he": 164,
	"./he.js": 164,
	"./hi": 165,
	"./hi.js": 165,
	"./hr": 166,
	"./hr.js": 166,
	"./hu": 167,
	"./hu.js": 167,
	"./hy-am": 168,
	"./hy-am.js": 168,
	"./id": 169,
	"./id.js": 169,
	"./is": 170,
	"./is.js": 170,
	"./it": 171,
	"./it.js": 171,
	"./ja": 172,
	"./ja.js": 172,
	"./jv": 173,
	"./jv.js": 173,
	"./ka": 174,
	"./ka.js": 174,
	"./kk": 175,
	"./kk.js": 175,
	"./km": 176,
	"./km.js": 176,
	"./kn": 177,
	"./kn.js": 177,
	"./ko": 178,
	"./ko.js": 178,
	"./ky": 179,
	"./ky.js": 179,
	"./lb": 180,
	"./lb.js": 180,
	"./lo": 181,
	"./lo.js": 181,
	"./lt": 182,
	"./lt.js": 182,
	"./lv": 183,
	"./lv.js": 183,
	"./me": 184,
	"./me.js": 184,
	"./mi": 185,
	"./mi.js": 185,
	"./mk": 186,
	"./mk.js": 186,
	"./ml": 187,
	"./ml.js": 187,
	"./mr": 188,
	"./mr.js": 188,
	"./ms": 190,
	"./ms-my": 189,
	"./ms-my.js": 189,
	"./ms.js": 190,
	"./my": 191,
	"./my.js": 191,
	"./nb": 192,
	"./nb.js": 192,
	"./ne": 193,
	"./ne.js": 193,
	"./nl": 195,
	"./nl-be": 194,
	"./nl-be.js": 194,
	"./nl.js": 195,
	"./nn": 196,
	"./nn.js": 196,
	"./pa-in": 197,
	"./pa-in.js": 197,
	"./pl": 198,
	"./pl.js": 198,
	"./pt": 200,
	"./pt-br": 199,
	"./pt-br.js": 199,
	"./pt.js": 200,
	"./ro": 201,
	"./ro.js": 201,
	"./ru": 202,
	"./ru.js": 202,
	"./sd": 203,
	"./sd.js": 203,
	"./se": 204,
	"./se.js": 204,
	"./si": 205,
	"./si.js": 205,
	"./sk": 206,
	"./sk.js": 206,
	"./sl": 207,
	"./sl.js": 207,
	"./sq": 208,
	"./sq.js": 208,
	"./sr": 210,
	"./sr-cyrl": 209,
	"./sr-cyrl.js": 209,
	"./sr.js": 210,
	"./ss": 211,
	"./ss.js": 211,
	"./sv": 212,
	"./sv.js": 212,
	"./sw": 213,
	"./sw.js": 213,
	"./ta": 214,
	"./ta.js": 214,
	"./te": 215,
	"./te.js": 215,
	"./tet": 216,
	"./tet.js": 216,
	"./th": 217,
	"./th.js": 217,
	"./tl-ph": 218,
	"./tl-ph.js": 218,
	"./tlh": 219,
	"./tlh.js": 219,
	"./tr": 220,
	"./tr.js": 220,
	"./tzl": 221,
	"./tzl.js": 221,
	"./tzm": 223,
	"./tzm-latn": 222,
	"./tzm-latn.js": 222,
	"./tzm.js": 223,
	"./uk": 224,
	"./uk.js": 224,
	"./ur": 225,
	"./ur.js": 225,
	"./uz": 227,
	"./uz-latn": 226,
	"./uz-latn.js": 226,
	"./uz.js": 227,
	"./vi": 228,
	"./vi.js": 228,
	"./x-pseudo": 229,
	"./x-pseudo.js": 229,
	"./yo": 230,
	"./yo.js": 230,
	"./zh-cn": 231,
	"./zh-cn.js": 231,
	"./zh-hk": 232,
	"./zh-hk.js": 232,
	"./zh-tw": 233,
	"./zh-tw.js": 233
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 426;

/***/ }),

/***/ 428:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(277),
  /* template */
  __webpack_require__(437),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 429:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(282),
  /* template */
  __webpack_require__(447),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 430:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(308)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(284),
  /* template */
  __webpack_require__(442),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 431:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(286),
  /* template */
  __webpack_require__(443),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 432:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(287),
  /* template */
  __webpack_require__(445),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 433:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(312)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(288),
  /* template */
  __webpack_require__(450),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 434:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(289),
  /* template */
  __webpack_require__(439),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 435:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(306)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(290),
  /* template */
  __webpack_require__(440),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 436:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [(!_vm.loading) ? _c('img', {
    staticClass: "lightbox__image",
    style: (_vm.style),
    attrs: {
      "src": _vm.image
    }
  }) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "lightbox__loading"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin fa-3x fa-fw"
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Loading...")])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 437:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui basic content center aligned segment"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isCreating),
      expression: "!isCreating"
    }],
    staticClass: "ui basic button icon",
    on: {
      "click": _vm.openForm
    }
  }, [_c('i', {
    staticClass: "plus icon"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isCreating),
      expression: "isCreating"
    }],
    staticClass: "ui centered card"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "ui form"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("Title")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.titleText),
      expression: "titleText"
    }],
    ref: "title",
    attrs: {
      "type": "text",
      "defaultValue": ""
    },
    domProps: {
      "value": (_vm.titleText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.titleText = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("Project")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.projectText),
      expression: "projectText"
    }],
    ref: "project",
    attrs: {
      "type": "text",
      "defaultValue": ""
    },
    domProps: {
      "value": (_vm.projectText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.projectText = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ui two button attached buttons"
  }, [_c('button', {
    staticClass: "ui basic blue button",
    on: {
      "click": function($event) {
        _vm.sendForm()
      }
    }
  }, [_vm._v("\n            Create\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "ui basic red button",
    on: {
      "click": _vm.closeForm
    }
  }, [_vm._v("\n            Cancel\n          ")])])])])])])
},staticRenderFns: []}

/***/ }),

/***/ 438:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "navbar-wrapper"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('nav', {
    staticClass: "navbar navbar-inverse navbar-static-top"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "navbar-collapse collapse",
    attrs: {
      "id": "navbar"
    }
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('li', {
    class: {
      active: _vm.activeClass === '/'
    }
  }, [_c('router-link', {
    attrs: {
      "to": '/'
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', {
    class: {
      active: _vm.activeClass === '/places'
    }
  }, [_c('router-link', {
    attrs: {
      "to": '/places'
    }
  }, [_vm._v("Places")])], 1), _vm._v(" "), _c('li', {
    class: {
      active: _vm.activeClass === '/photos'
    }
  }, [_c('router-link', {
    attrs: {
      "to": '/photos'
    }
  }, [_vm._v("Photos")])], 1), _vm._v(" "), _vm._m(1)])])])])])]), _vm._v(" "), _c('nav', [_c('router-view')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar-header"
  }, [_c('button', {
    staticClass: "navbar-toggle collapsed",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#navbar",
      "aria-expanded": "false",
      "aria-controls": "navbar"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })]), _vm._v(" "), _c('a', {
    staticClass: "navbar-brand",
    attrs: {
      "href": "/"
    }
  }, [_vm._v("McAnoy.com")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "http://mcanoy.github.io"
    }
  }, [_vm._v("Tech Things")])])
}]}

/***/ }),

/***/ 439:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.label)
    }
  }), _vm._v(" "), _c('input', {
    ref: "input",
    class: _vm.className,
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    }
  })])
},staticRenderFns: []}

/***/ }),

/***/ 440:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-street-view-pano-container"
  }, [_c('div', {
    ref: "vue-street-view-pano",
    staticClass: "vue-street-view-pano"
  }), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 441:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('h1'), _c('h1'), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.setDetails.name)), _c('small', [_vm._v(_vm._s(_vm.setDetails.description))])]), _vm._v(" "), _c('div', {
    staticClass: "flexbin flexbin-margin"
  }, _vm._l((_vm.imageItems), function(image) {
    return _c('a', {
      directives: [{
        name: "lightbox",
        rawName: "v-lightbox"
      }],
      attrs: {
        "href": image.urlLarge
      }
    }, [_c('img', {
      attrs: {
        "src": image.urlSmall
      }
    })])
  }))])]), _vm._v(" "), _c('lightbox')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 442:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.image) ? _c('div', {
    staticClass: "lightbox",
    on: {
      "click": _vm.close
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.transition
    }
  }, [_c('lightbox-image', {
    key: _vm.image,
    attrs: {
      "image": _vm.image
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "lightbox__close",
    on: {
      "click": _vm.close
    }
  }, [_c('i', {
    staticClass: "fa fa-close fa-3x"
  })]), _vm._v(" "), _c('div', {
    staticClass: "lightbox__btn lightbox__next",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.next($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-right fa-3x"
  })]), _vm._v(" "), _c('div', {
    staticClass: "lightbox__btn lightbox__prev",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.prev($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left fa-3x"
  })])], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 443:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    ref: "input",
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.value
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ 444:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "about"
    }
  }, [_c('todo-list', {
    attrs: {
      "todos": _vm.todos
    }
  }), _vm._v(" "), _c('create-todo', {
    on: {
      "create-todo": _vm.createTodo
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 445:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    ref: "flyaway"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),

/***/ 446:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("Completed Tasks: " + _vm._s(_vm.todos.filter(function (todo) {
    return todo.done === true
  }).length))]), _vm._v(" "), _c('p', [_vm._v("Pending Tasks: " + _vm._s(_vm.todos.filter(function (todo) {
    return todo.done === false
  }).length))]), _vm._v(" "), _vm._l((_vm.todos), function(todo) {
    return _c('todo', {
      attrs: {
        "todo": todo
      },
      on: {
        "delete-todo": _vm.deleteTodo,
        "complete-todo": _vm.completeTodo
      }
    })
  })], 2)
},staticRenderFns: []}

/***/ }),

/***/ 447:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui centered card"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isEditing),
      expression: "!isEditing"
    }],
    staticClass: "content"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("\n            " + _vm._s(_vm.todo.title) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "meta"
  }, [_vm._v("\n            " + _vm._s(_vm.todo.project) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "extra content"
  }, [_c('span', {
    staticClass: "right floated edit icon",
    on: {
      "click": _vm.showForm
    }
  }, [_c('i', {
    staticClass: "edit icon"
  })]), _vm._v(" "), _c('span', {
    staticClass: "right floated trash icon",
    on: {
      "click": function($event) {
        _vm.deleteTodo(_vm.todo)
      }
    }
  }, [_c('i', {
    staticClass: "trash icon"
  })])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isEditing),
      expression: "isEditing"
    }],
    staticClass: "content"
  }, [_c('div', {
    staticClass: "ui form"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("Title")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.todo.title),
      expression: "todo.title"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.todo.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.todo.title = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("Project")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.todo.project),
      expression: "todo.project"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.todo.project)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.todo.project = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ui two button attached buttons"
  }, [_c('button', {
    staticClass: "ui basic blue button",
    on: {
      "click": _vm.hideForm
    }
  }, [_vm._v("\n                    Close X\n                ")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.todo.done),
      expression: "todo.done"
    }],
    staticClass: "ui bottom attached green basic button"
  }, [_vm._v("\n        Completed\n    ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.todo.done),
      expression: "!todo.done"
    }],
    staticClass: "ui bottom attached red basic button",
    on: {
      "click": function($event) {
        _vm.completeTodo(_vm.todo)
      }
    }
  }, [_vm._v("\n        Complete\n    ")])])
},staticRenderFns: []}

/***/ }),

/***/ 448:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "carousel slide",
    attrs: {
      "id": "myCarousel",
      "data-ride": "carousel"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "carousel-inner",
    attrs: {
      "role": "listbox"
    }
  }, [_c('div', {
    staticClass: "item active"
  }, [_c('img', {
    staticClass: "first-slide",
    attrs: {
      "src": _vm.contentList[0].thumbnail,
      "alt": "First slide"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "carousel-caption"
  }, [_c('h1', [_vm._v(_vm._s(_vm.contentList[0].name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.contentList[0].description))]), _vm._v(" "), _c('p', [_c('router-link', {
    staticClass: "btn btn-lg btn-primary",
    attrs: {
      "to": '/photos/' + _vm.setNamePlus(_vm.contentList[0]),
      "role": "button"
    }
  }, [_vm._v("View Gallery")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('img', {
    staticClass: "second-slide",
    attrs: {
      "src": _vm.contentList[1].thumbnail,
      "alt": "Second slide"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "carousel-caption"
  }, [_c('h1', [_vm._v(_vm._s(_vm.contentList[1].name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.contentList[1].description))]), _vm._v(" "), _c('p', [_c('router-link', {
    staticClass: "btn btn-lg btn-primary",
    attrs: {
      "to": '/photos/' + _vm.setNamePlus(_vm.contentList[1]),
      "role": "button"
    }
  }, [_vm._v("View Gallery")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('img', {
    staticClass: "third-slide",
    attrs: {
      "src": _vm.contentList[2].thumbnail,
      "alt": "Third slide"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "carousel-caption"
  }, [_c('h1', [_vm._v(_vm._s(_vm.contentList[2].name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.contentList[2].description))]), _vm._v(" "), _c('p', [_c('router-link', {
    staticClass: "btn btn-lg btn-primary",
    attrs: {
      "to": '/photos/' + _vm.setNamePlus(_vm.contentList[2]),
      "role": "button"
    }
  }, [_vm._v("View Gallery")])], 1)])])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "container marketing"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4 col-md-4"
  }, [_c('img', {
    staticClass: "img-circle",
    attrs: {
      "src": 'https://maps.googleapis.com/maps/api/staticmap?zoom=11&size=140x140&markers=color:blue%7Clabel:' + _vm.firstLetter(_vm.placesList[0].name) + '%7C' + _vm.placesList[0].latitude + ',' + _vm.placesList[0].longitude + '&key=' + _vm.api_key,
      "width": "140",
      "height": "140"
    }
  }), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.placesList[0].name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.placesList[0].description))]), _vm._v(" "), _c('p', [_c('router-link', {
    staticClass: "btn btn-default",
    attrs: {
      "to": '/places/' + _vm.setNamePlus(_vm.placesList[0]),
      "role": "button"
    }
  }, [_vm._v("View details »")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4  col-md-4"
  }, [_c('img', {
    staticClass: "img-circle",
    attrs: {
      "src": 'https://maps.googleapis.com/maps/api/staticmap?zoom=11&size=140x140&markers=color:blue%7Clabel:' + _vm.firstLetter(_vm.placesList[1].name) + '%7C' + _vm.placesList[1].latitude + ',' + _vm.placesList[1].longitude + '&key=' + _vm.api_key,
      "width": "140",
      "height": "140"
    }
  }), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.placesList[1].name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.placesList[1].description))]), _vm._v(" "), _c('p', [_c('router-link', {
    staticClass: "btn btn-default",
    attrs: {
      "to": '/places/' + _vm.setNamePlus(_vm.placesList[1]),
      "role": "button"
    }
  }, [_vm._v("View details »")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4  col-md-4"
  }, [_c('img', {
    staticClass: "img-circle",
    attrs: {
      "src": 'https://maps.googleapis.com/maps/api/staticmap?zoom=11&size=140x140&markers=color:blue%7Clabel:' + _vm.firstLetter(_vm.placesList[2].name) + '%7C' + _vm.placesList[2].latitude + ',' + _vm.placesList[2].longitude + '&key=' + _vm.api_key,
      "width": "140",
      "height": "140"
    }
  }), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.placesList[2].name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.placesList[2].description))]), _vm._v(" "), _c('p', [_c('router-link', {
    staticClass: "btn btn-default",
    attrs: {
      "to": '/places/' + _vm.setNamePlus(_vm.placesList[2]),
      "role": "button"
    }
  }, [_vm._v("View details »")])], 1)])]), _vm._v(" "), _c('hr', {
    staticClass: "featurette-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "row featurette"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('h2', {
    staticClass: "featurette-heading"
  }, [_vm._v(_vm._s(_vm.postsList[0].title) + " "), _c('span', {
    staticClass: "text-muted"
  })]), _vm._v(" "), _c('p', {
    staticClass: "lead"
  }, [_vm._v(_vm._s(_vm.postsList[0].content) + " ...")]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "btn btn-default",
    attrs: {
      "href": _vm.postsList[0].url,
      "role": "button"
    }
  }, [_vm._v("Read More »")])])]), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('hr', {
    staticClass: "featurette-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "row featurette"
  }, [_c('div', {
    staticClass: "col-md-7 col-md-push-5"
  }, [_c('h2', {
    staticClass: "featurette-heading"
  }, [_vm._v(_vm._s(_vm.postsList[1].title) + " "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("See for yourself.")])]), _vm._v(" "), _c('p', {
    staticClass: "lead"
  }, [_vm._v(_vm._s(_vm.postsList[1].content) + " ...")]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "btn btn-default",
    attrs: {
      "href": _vm.postsList[1].url,
      "role": "button"
    }
  }, [_vm._v("Read More »")])])]), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('hr', {
    staticClass: "featurette-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "row featurette"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('h2', {
    staticClass: "featurette-heading"
  }, [_vm._v(_vm._s(_vm.postsList[2].title) + " "), _c('span', {
    staticClass: "text-muted"
  })]), _vm._v(" "), _c('p', {
    staticClass: "lead"
  }, [_vm._v(_vm._s(_vm.postsList[2].content) + " ...")]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "btn btn-default",
    attrs: {
      "href": _vm.postsList[2].url,
      "role": "button"
    }
  }, [_vm._v("Read More »")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('img', {
    staticClass: "featurette-image img-responsive center-block",
    attrs: {
      "src": _vm.contentList[0].thumbnail,
      "alt": "First slide"
    }
  })])]), _vm._v(" "), _c('hr', {
    staticClass: "featurette-divider"
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticClass: "carousel-indicators"
  }, [_c('li', {
    staticClass: "active",
    attrs: {
      "data-target": "#myCarousel",
      "data-slide-to": "0"
    }
  }), _vm._v(" "), _c('li', {
    attrs: {
      "data-target": "#myCarousel",
      "data-slide-to": "1"
    }
  }), _vm._v(" "), _c('li', {
    attrs: {
      "data-target": "#myCarousel",
      "data-slide-to": "2"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "left carousel-control",
    attrs: {
      "href": "#myCarousel",
      "role": "button",
      "data-slide": "prev"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-left",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Previous")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "right carousel-control",
    attrs: {
      "href": "#myCarousel",
      "role": "button",
      "data-slide": "next"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-right",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Next")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-5"
  }, [_c('img', {
    staticClass: "featurette-image img-responsive center-block",
    attrs: {
      "src": "https://blog.openshift.com/wp-content/uploads/DevOps-Covey-768x576.png",
      "alt": "First slide"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-5 col-md-pull-7"
  }, [_c('img', {
    staticClass: "featurette-image img-responsive center-block",
    attrs: {
      "src": "https://kubernetes.io/images/favicon.png",
      "alt": "First slide"
    }
  })])
}]}

/***/ }),

/***/ 449:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "root"
    }
  }, [_c('gmap-map', {
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "position": "absolute",
      "left": "0",
      "top": "0"
    },
    attrs: {
      "center": _vm.center,
      "zoom": _vm.zoom
    }
  }, [_c('gmap-cluster', [_vm._l((_vm.markers), function(m, i) {
    return _c('gmap-marker', {
      key: m.id,
      attrs: {
        "label": _vm.firstLetter(m),
        "position": {
          lat: m.latitude,
          lng: m.longitude
        },
        "clickable": true,
        "draggable": false,
        "icon": _vm.getIcon(m)
      },
      on: {
        "click": function($event) {
          _vm.toggleInfoWindow(m, i)
        }
      }
    })
  }), _vm._v(" "), _c('gmap-info-window', {
    attrs: {
      "options": _vm.infoOptions,
      "position": _vm.infoWindowPos,
      "opened": _vm.infoWinOpen,
      "content": _vm.infoContent
    },
    on: {
      "closeclick": function($event) {
        _vm.infoWinOpen = false
      }
    }
  })], 2)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 450:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-map-container"
  }, [_c('div', {
    ref: "vue-map",
    staticClass: "vue-map"
  }), _vm._v(" "), _c('div', {
    staticClass: "vue-map-hidden"
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("visible")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 451:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container outerpadding"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.sets), function(set, i) {
    return _c('div', {
      staticClass: "col-lg-3 col-md-3 col-sm-4 col-xs-12"
    }, [_c('div', {
      staticClass: "panel"
    }, [_c('router-link', {
      attrs: {
        "to": '/photos/' + _vm.setNamePlus(set),
        "title": set.description
      }
    }, [_c('div', {
      staticClass: "panel-heading",
      staticStyle: {
        "background-color": "#530100",
        "color": "#fff"
      }
    }, [_c('strong', [_vm._v(_vm._s(set.name) + " ")])]), _vm._v(" "), _c('div', {
      staticClass: "panel-body",
      staticStyle: {
        "background-color": "#000",
        "color": "#fff",
        "box-shadow": "0 -12px 13px #530100 inset"
      }
    }, [_c('div', {
      staticClass: "boximg"
    }, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": set.boxThumbnail
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "label label-danger date"
    }, [_vm._v(_vm._s(_vm.formatDate(set.displayDate)))]), _vm._v(" "), _c('span', {
      staticClass: "likebut glyphicon glyphicon-tag"
    })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
      staticClass: "pull-left"
    }, [_vm._v(_vm._s(_vm.maxChars(set.description, 22)) + " ")]), _vm._v(" "), _c('span', {
      staticClass: "badge pull-right",
      staticStyle: {
        "background-color": "#530100"
      }
    }, [_vm._v(_vm._s(set.count))])])])], 1)])
  }))])
},staticRenderFns: []}

/***/ }),

/***/ 452:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "carousel slide",
    attrs: {
      "id": "myCarousel",
      "data-ride": "carousel"
    }
  }, [_c('ol', {
    staticClass: "carousel-indicators"
  }, [_c('li', {
    staticClass: "active",
    attrs: {
      "data-target": "#myCarousel",
      "data-slide-to": "0"
    }
  }), _vm._v(" "), _c('li', {
    attrs: {
      "data-target": "#myCarousel",
      "data-slide-to": "1"
    }
  }), _vm._v(" "), _c('li', {
    attrs: {
      "data-target": "#myCarousel",
      "data-slide-to": "2"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "carousel-inner",
    attrs: {
      "role": "listbox"
    }
  }, [_c('div', {
    staticClass: "item active"
  }, [_c('img', {
    staticClass: "first-slide",
    attrs: {
      "src": "data:image/gif;base64,R0lGODlhAQABAIAAAHd3dwAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw==",
      "alt": "First slide"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "carousel-caption"
  }, [_c('h1', [_vm._v("Example headline.")]), _vm._v(" "), _c('p', [_vm._v("Note: If you're viewing this page via a "), _c('code', [_vm._v("file://")]), _vm._v(" URL, the \"next\" and \"previous\" Glyphicon buttons on the left and right might not load/display properly due to web browser security rules.")]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "btn btn-lg btn-primary",
    attrs: {
      "href": "#",
      "role": "button"
    }
  }, [_vm._v("Sign up today")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('img', {
    staticClass: "second-slide",
    attrs: {
      "src": "data:image/gif;base64,R0lGODlhAQABAIAAAHd3dwAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw==",
      "alt": "Second slide"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "carousel-caption"
  }, [_c('h1', [_vm._v("Another example headline.")]), _vm._v(" "), _c('p', [_vm._v("Cras justo odio, dapibus ac facilisis in, egestas eget quam. Donec id elit non mi porta gravida at eget metus. Nullam id dolor id nibh ultricies vehicula ut id elit.")]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "btn btn-lg btn-primary",
    attrs: {
      "href": "#",
      "role": "button"
    }
  }, [_vm._v("Learn more")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('img', {
    staticClass: "third-slide",
    attrs: {
      "src": "data:image/gif;base64,R0lGODlhAQABAIAAAHd3dwAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw==",
      "alt": "Third slide"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "carousel-caption"
  }, [_c('h1', [_vm._v("One more for good measure.")]), _vm._v(" "), _c('p', [_vm._v("Cras justo odio, dapibus ac facilisis in, egestas eget quam. Donec id elit non mi porta gravida at eget metus. Nullam id dolor id nibh ultricies vehicula ut id elit.")]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "btn btn-lg btn-primary",
    attrs: {
      "href": "#",
      "role": "button"
    }
  }, [_vm._v("Browse gallery")])])])])])]), _vm._v(" "), _c('a', {
    staticClass: "left carousel-control",
    attrs: {
      "href": "#myCarousel",
      "role": "button",
      "data-slide": "prev"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-left",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Previous")])]), _vm._v(" "), _c('a', {
    staticClass: "right carousel-control",
    attrs: {
      "href": "#myCarousel",
      "role": "button",
      "data-slide": "next"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-right",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Next")])])]), _vm._v(" "), _c('div', {
    staticClass: "container marketing"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4"
  }, [_c('img', {
    staticClass: "img-circle",
    attrs: {
      "src": "data:image/gif;base64,R0lGODlhAQABAIAAAHd3dwAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw==",
      "alt": "Generic placeholder image",
      "width": "140",
      "height": "140"
    }
  }), _vm._v(" "), _c('h2', [_vm._v("Heading")]), _vm._v(" "), _c('p', [_vm._v("Donec sed odio dui. Etiam porta sem malesuada magna mollis euismod. Nullam id dolor id nibh ultricies vehicula ut id elit. Morbi leo risus, porta ac consectetur ac, vestibulum at eros. Praesent commodo cursus magna.")]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "btn btn-default",
    attrs: {
      "href": "#",
      "role": "button"
    }
  }, [_vm._v("View details »")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('img', {
    staticClass: "img-circle",
    attrs: {
      "src": "data:image/gif;base64,R0lGODlhAQABAIAAAHd3dwAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw==",
      "alt": "Generic placeholder image",
      "width": "140",
      "height": "140"
    }
  }), _vm._v(" "), _c('h2', [_vm._v("Heading")]), _vm._v(" "), _c('p', [_vm._v("Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit. Cras mattis consectetur purus sit amet fermentum. Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh.")]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "btn btn-default",
    attrs: {
      "href": "#",
      "role": "button"
    }
  }, [_vm._v("View details »")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('img', {
    staticClass: "img-circle",
    attrs: {
      "src": "data:image/gif;base64,R0lGODlhAQABAIAAAHd3dwAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw==",
      "alt": "Generic placeholder image",
      "width": "140",
      "height": "140"
    }
  }), _vm._v(" "), _c('h2', [_vm._v("Heading")]), _vm._v(" "), _c('p', [_vm._v("Donec sed odio dui. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Vestibulum id ligula porta felis euismod semper. Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus.")]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "btn btn-default",
    attrs: {
      "href": "#",
      "role": "button"
    }
  }, [_vm._v("View details »")])])])]), _vm._v(" "), _c('hr', {
    staticClass: "featurette-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "row featurette"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('h2', {
    staticClass: "featurette-heading"
  }, [_vm._v("First featurette heading. "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("It'll blow your mind.")])]), _vm._v(" "), _c('p', {
    staticClass: "lead"
  }, [_vm._v("Donec ullamcorper nulla non metus auctor fringilla. Vestibulum id ligula porta felis euismod semper. Praesent commodo cursus magna, vel scelerisque nisl consectetur. Fusce dapibus, tellus ac cursus commodo.")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('img', {
    staticClass: "featurette-image img-responsive center-block",
    attrs: {
      "data-src": "holder.js/500x500/auto",
      "alt": "Generic placeholder image"
    }
  })])]), _vm._v(" "), _c('hr', {
    staticClass: "featurette-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "row featurette"
  }, [_c('div', {
    staticClass: "col-md-7 col-md-push-5"
  }, [_c('h2', {
    staticClass: "featurette-heading"
  }, [_vm._v("Oh yeah, it's that good. "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("See for yourself.")])]), _vm._v(" "), _c('p', {
    staticClass: "lead"
  }, [_vm._v("Donec ullamcorper nulla non metus auctor fringilla. Vestibulum id ligula porta felis euismod semper. Praesent commodo cursus magna, vel scelerisque nisl consectetur. Fusce dapibus, tellus ac cursus commodo.")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 col-md-pull-7"
  }, [_c('img', {
    staticClass: "featurette-image img-responsive center-block",
    attrs: {
      "data-src": "holder.js/500x500/auto",
      "alt": "Generic placeholder image"
    }
  })])]), _vm._v(" "), _c('hr', {
    staticClass: "featurette-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "row featurette"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('h2', {
    staticClass: "featurette-heading"
  }, [_vm._v("And lastly, this one. "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("Checkmate.")])]), _vm._v(" "), _c('p', {
    staticClass: "lead"
  }, [_vm._v("Donec ullamcorper nulla non metus auctor fringilla. Vestibulum id ligula porta felis euismod semper. Praesent commodo cursus magna, vel scelerisque nisl consectetur. Fusce dapibus, tellus ac cursus commodo.")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('img', {
    staticClass: "featurette-image img-responsive center-block",
    attrs: {
      "data-src": "holder.js/500x500/auto",
      "alt": "Generic placeholder image"
    }
  })])]), _vm._v(" "), _c('hr', {
    staticClass: "featurette-divider"
  })])])
}]}

/***/ }),

/***/ 47:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var LightboxStore = function () {
  function LightboxStore() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, LightboxStore);

    this.state = {
      images: [],
      index: false
    };
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(LightboxStore, [{
    key: "addImage",
    value: function addImage(url) {
      return this.state.images.push(url) - 1;
    }
  }, {
    key: "removeImage",
    value: function removeImage(url) {
      this.state.images = this.state.images.filter(function (image) {
        return image !== url;
      });
    }
  }, {
    key: "open",
    value: function open(index) {
      this.state.index = index;
    }
  }, {
    key: "close",
    value: function close() {
      this.state.index = false;
    }
  }, {
    key: "next",
    value: function next() {
      this.state.index += 1;
      if (this.state.index >= this.state.images.length) {
        this.state.index = 0;
      }
    }
  }, {
    key: "prev",
    value: function prev() {
      this.state.index -= 1;
      if (this.state.index < 0) {
        this.state.index = this.state.images.length - 1;
      }
    }
  }]);

  return LightboxStore;
}();

/* harmony default export */ __webpack_exports__["a"] = (new LightboxStore());

/***/ }),

/***/ 81:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(310)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(283),
  /* template */
  __webpack_require__(446),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

},[274]);


// WEBPACK FOOTER //
// static/js/app.b583b3d5f553af9c0d5b.js